import { Page } from '@app/components/page/Page';
import { useActiveStation } from '@app/core/stations/hooks/useActiveStation';
import Grid from '@mui/material/Grid2'; // Grid version 2
import { useIntl } from 'react-intl';
import { StationAuditPage } from '../../components/StationAuditPage';
import { UploadLinks } from './components/common/UploadLinks';
import { UploadView } from './components/common/UploadView';

export function StationUploadPage() {
  const station = useActiveStation();
  const { $t } = useIntl();

  return (
    <StationAuditPage
      title={$t({
        id: 'audit.uploadScreen.title',
        defaultMessage: 'Cargar archivos',
      })}
    >
      <Page.Content>
        <Grid container>
          <Grid size={{ md: 2 }}>
            <UploadLinks />
          </Grid>
          <Grid size="grow">
            <UploadView station={station} />
          </Grid>
        </Grid>
      </Page.Content>
    </StationAuditPage>
  );
}
